import { Route, Routes } from 'react-router-dom';

import CheckoutDesignForm from './CheckoutDesignForm';
import { CheckoutDesignTable } from './CheckoutDesignTable';

import '../../views/view.scss';

const CheckoutDesignView = () => {
  return (
    <Routes>
      <Route path="/" element={<CheckoutDesignTable />} />
      <Route path="/form" element={<CheckoutDesignForm />} />
      <Route
        path="/form/:templateId"
        element={<CheckoutDesignForm edit={true} />}
      />
      <Route
        path="/dup/:templateId"
        element={<CheckoutDesignForm edit={false} dup={true} />}
      />
    </Routes>
  );
};

export default CheckoutDesignView;
